import { Text } from "@chakra-ui/react"
import { Link, navigate } from "gatsby"
import React, { useEffect } from "react"
import { Logo } from "../logo"
import "./styles.css"
import { OursLines } from "../../mocks/oursLine"

export const Header = () => {
  const [showMenu, setShowMenu] = React.useState(false)
  const [pathName, setPathName] = React.useState("/")
  const [openDropdown, setOpenDropdown] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);

  useEffect(() => {
    function handleResize() {
      setShowMenu(false);
      setIsMobile(window.innerWidth < 1366);
    }

    handleResize(); // Executa na montagem para pegar o tamanho atual da janela

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Coloquei o array de dependências vazio para garantir que rode só uma vez na montagem

  const toggleMenu = () => {
    setShowMenu(!showMenu)
  }

  const handleNavigate = (url: string) => {
    navigate(url)
    setShowMenu(false)
    setPathName(url)
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      setPathName(window.location.pathname)
    }
  }, [])

  const classActive = (pathLink: string) => {
    return pathLink === pathName ? `nav-link active` : `nav-link`
  }

  const [isMobile, setIsMobile] = React.useState(false);


  const [scrolled, setScrolled] = React.useState(false);



  return (
    <>
      <div className={`menu__wrapper ${showMenu ? "show" : ""}`}>
        <div className="menu--body">
          <div style={{ width: "100%", height: "50px" }} />
          <ul className="nav--items list-unstyled">
            <li>
              <Text as="a" onClick={() => handleNavigate("/")}>
                <a href="/">
                  Home
                </a>
              </Text>
            </li>
            <li>
              <Text as="a" onClick={() => handleNavigate("/nossa-historia")}>
                <a href="/nossa-historia">
                  Nossa História
                </a>
              </Text>
            </li>
            <li className="nav-item">
              <a
              href="javascript:void(0)"
                onClick={() => setOpenDropdown(!openDropdown)}
                className="d-flex flex-row gap-1 align-items-center"
              >
                Nossas Linhas
                {openDropdown ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-up ms-2" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M8 4.5a.5.5 0 0 1 .374.156l4 4a.5.5 0 1 1-.748.664L8 5.707 4.374 9.32a.5.5 0 1 1-.748-.664l4-4A.5.5 0 0 1 8 4.5z" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down ms-2" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                  </svg>
                )}

              </a>
              {openDropdown && (
                <ul className="nav flex-column ps-3 mt-2">
                  {OursLines.map((item) => (
                    <li className="nav-item mb-1" key={`linhas-mobile-${item.path}`}>
                      <Link
                        className="nav-link"
                        to={`/nossas-linhas/${item.path}`}
                        onClick={() => handleNavigate(`/nossas-linhas/${item.path}`)}
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
            <li>
              <Text as="a" onClick={() => handleNavigate("/receitas")}>
                <a href="/receitas">
                  Receitas
                </a>
              </Text>
            </li>
            <li>
              <a href="https://espacodanutri.com.br/" target="_blank">
                Espaço da Nutri
              </a>
            </li>
            <li>
              <Text as="a" onClick={() => handleNavigate("/faq")}>
                <a href="/faq">
                  Dúvidas
                </a>
              </Text>
            </li>
            <li>
              <Text as="a" onClick={() => handleNavigate("/blog")}>
                <a href="/blog">
                  Blog
                </a>
              </Text>
            </li>
          </ul>
        </div>
        <div className="menu--footer py-4">
          <div className="social-network">
            <div className="col-sm-6 mx-auto">
              <ul className="d-flex flex-row justify-content-between mx-auto list-unstyled">
                <li>
                  <a
                    href="https://www.facebook.com/VerdeCampoLat/"
                    target="_blank"
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10 4H22.0053C25.316 4 28 6.684 28 9.99467V22.0067C28 25.316 25.316 28 22.0053 28H9.99467C6.684 28 4 25.316 4 22.0053V10C4 6.68667 6.68667 4 10 4V4Z"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.8 17.2H22"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M22 11.2H20.74C18.7853 11.2 17.2 12.7853 17.2 14.74V16V28"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.instagram.com/verdecampo/?hl=en"
                    target="_blank"
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.99467 4H22.0067C25.316 4 28 6.68267 28 9.99467V22.0067C28 25.316 25.3173 28 22.0053 28H9.99467C6.684 28 4 25.3173 4 22.0053V9.99467C4 6.684 6.68267 4 9.99467 4V4Z"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M22.5986 8.95068C22.3506 8.95201 22.1493 9.15334 22.1493 9.40134C22.1493 9.64934 22.3519 9.85068 22.5999 9.85068C22.8479 9.85068 23.0493 9.64934 23.0493 9.40134C23.0506 9.15201 22.8479 8.95068 22.5986 8.95068"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M19.3942 12.6058C21.2687 14.4804 21.2687 17.5195 19.3942 19.3941C17.5197 21.2686 14.4805 21.2686 12.606 19.3941C10.7314 17.5195 10.7314 14.4804 12.606 12.6058C14.4805 10.7313 17.5197 10.7313 19.3942 12.6058"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.youtube.com/channel/UCtMLPcsIDuuWualxo-DfM6A"
                    target="_blank"
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M28.7773 8.49737C28.472 7.1587 27.568 6.1027 26.4186 5.74003C24.34 5.0907 16 5.0907 16 5.0907C16 5.0907 7.66396 5.0907 5.58129 5.74003C4.43596 6.09736 3.53196 7.15337 3.22263 8.49737C2.66663 10.9267 2.66663 16 2.66663 16C2.66663 16 2.66663 21.0734 3.22263 23.5027C3.52796 24.8414 4.43196 25.8974 5.58129 26.26C7.66396 26.9094 16 26.9094 16 26.9094C16 26.9094 24.34 26.9094 26.4186 26.26C27.564 25.9027 28.468 24.8467 28.7773 23.5027C29.3333 21.0734 29.3333 16 29.3333 16C29.3333 16 29.3333 10.9267 28.7773 8.49737Z"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13.3359 20L20.2639 16L13.3359 12V20Z"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </li>

                <li>
                  <a
                    href="https://twitter.com/verdecampo_br?lang=en"
                    target="_blank"
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M26.35 12.4667C26.35 12.0525 26.0142 11.7167 25.6 11.7167C25.1858 11.7167 24.85 12.0525 24.85 12.4667H26.35ZM4.60565 21.6243C4.36134 21.2898 3.89213 21.2167 3.55764 21.461C3.22314 21.7053 3.15004 22.1745 3.39435 22.509L4.60565 21.6243ZM3.87257 21.3276C3.46438 21.398 3.19053 21.7859 3.2609 22.1941C3.33128 22.6023 3.71924 22.8761 4.12743 22.8058L3.87257 21.3276ZM7.6 20.8667L7.83829 21.5778C8.08386 21.4955 8.26961 21.2924 8.3296 21.0404C8.3896 20.7885 8.31535 20.5234 8.13322 20.3392L7.6 20.8667ZM6.4 6.46667L7.06058 6.11152C6.93797 5.88346 6.70639 5.73478 6.44798 5.71821C6.18958 5.70164 5.94091 5.81954 5.79018 6.03007L6.4 6.46667ZM13.6 12.4667L13.4229 13.1955C13.6422 13.2488 13.8739 13.2004 14.0537 13.0639C14.2334 12.9273 14.3421 12.7171 14.3496 12.4915L13.6 12.4667ZM24.4 8.86667L23.7738 9.27945C23.9126 9.48997 24.1479 9.61667 24.4 9.61667V8.86667ZM28 8.86667L28.624 9.2827C28.7775 9.05256 28.7918 8.75665 28.6613 8.51278C28.5307 8.26891 28.2766 8.11667 28 8.11667V8.86667ZM24.976 12.0506C24.7462 12.3953 24.8393 12.8609 25.184 13.0907C25.5286 13.3205 25.9943 13.2273 26.224 12.8827L24.976 12.0506ZM24.85 12.4667C24.85 16.5286 23.6901 19.9377 21.5876 22.3205C19.4954 24.6916 16.4093 26.1167 12.4 26.1167V27.6167C16.7907 27.6167 20.3046 26.0417 22.7124 23.3129C25.1099 20.5957 26.35 16.8047 26.35 12.4667H24.85ZM12.4 26.1167C10.1446 26.1167 8.61715 25.5325 7.46172 24.7149C6.28337 23.8811 5.44722 22.7765 4.60565 21.6243L3.39435 22.509C4.22878 23.6515 5.19263 24.9469 6.59528 25.9394C8.02085 26.9481 9.85542 27.6167 12.4 27.6167V26.1167ZM4.12743 22.8058C4.15123 22.8017 4.16967 22.7973 4.17608 22.7957C4.1848 22.7936 4.19188 22.7918 4.19617 22.7906C4.20475 22.7883 4.21182 22.7862 4.21566 22.7851C4.22379 22.7827 4.23145 22.7804 4.23688 22.7787C4.24841 22.7751 4.26236 22.7706 4.27722 22.7658C4.3075 22.7561 4.34936 22.7424 4.40026 22.7256C4.50245 22.692 4.6456 22.6445 4.81543 22.5881C5.15532 22.4751 5.60456 22.3251 6.05223 22.1755C6.49998 22.0259 6.94649 21.8764 7.28104 21.7644C7.44832 21.7084 7.58762 21.6618 7.68511 21.6291C7.73385 21.6128 7.77214 21.6 7.79825 21.5912C7.8113 21.5869 7.82131 21.5835 7.82805 21.5812C7.83143 21.5801 7.83398 21.5793 7.8357 21.5787C7.83656 21.5784 7.8372 21.5782 7.83764 21.578C7.83785 21.578 7.83802 21.5779 7.83812 21.5779C7.83818 21.5779 7.83822 21.5778 7.83825 21.5778C7.83827 21.5778 7.83829 21.5778 7.6 20.8667C7.36171 20.1555 7.3617 20.1555 7.36167 20.1555C7.36164 20.1556 7.3616 20.1556 7.36155 20.1556C7.36144 20.1556 7.36128 20.1557 7.36107 20.1558C7.36064 20.1559 7.35999 20.1561 7.35914 20.1564C7.35743 20.157 7.35488 20.1578 7.35151 20.159C7.34478 20.1612 7.33478 20.1646 7.32174 20.1689C7.29566 20.1777 7.2574 20.1905 7.20869 20.2068C7.11126 20.2394 6.97204 20.2861 6.80484 20.342C6.47043 20.454 6.02419 20.6033 5.57677 20.7528C5.12928 20.9024 4.68093 21.052 4.34219 21.1647C4.17271 21.221 4.03129 21.2679 3.93132 21.3008C3.88114 21.3173 3.84252 21.3299 3.81639 21.3384C3.80303 21.3427 3.79479 21.3453 3.79058 21.3466C3.78814 21.3474 3.78954 21.3469 3.79307 21.3459C3.79461 21.3454 3.7998 21.3439 3.80693 21.342C3.81049 21.341 3.81694 21.3393 3.82514 21.3374C3.83104 21.3359 3.84907 21.3316 3.87257 21.3276L4.12743 22.8058ZM8.13322 20.3392C4.38741 16.5523 4.10617 10.9589 7.00982 6.90328L5.79018 6.03007C2.46983 10.6677 2.79659 17.077 7.06678 21.3941L8.13322 20.3392ZM5.73942 6.82183C7.28849 9.70308 10.1972 12.4115 13.4229 13.1955L13.7771 11.7379C11.0668 11.0792 8.46351 8.72094 7.06058 6.11152L5.73942 6.82183ZM14.3496 12.4915C14.4015 10.9221 14.9564 9.60801 15.8535 8.69124C16.7467 7.77855 18.0202 7.21667 19.6 7.21667V5.71667C17.6451 5.71667 15.976 6.42146 14.7815 7.64211C13.591 8.85867 12.9132 10.5445 12.8504 12.4419L14.3496 12.4915ZM19.6 7.21667C20.7065 7.21667 21.5356 7.42692 22.1829 7.77235C22.8285 8.11691 23.3396 8.6207 23.7738 9.27945L25.0262 8.4539C24.4831 7.62999 23.7975 6.93377 22.8891 6.449C21.9824 5.9651 20.9002 5.71667 19.6 5.71667V7.21667ZM24.4 9.61667H28V8.11667H24.4V9.61667ZM27.376 8.45065L24.976 12.0506L26.224 12.8827L28.624 9.2827L27.376 8.45065Z"
                        fill="#F1F3F5"
                      />
                    </svg>
                  </a>
                </li>

                <li>
                  <a
                    href="https://br.linkedin.com/company/laticinio-verde-campo"
                    target="_blank"
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10 4H22.0053C25.316 4 28 6.684 28 9.99467V22.0067C28 25.316 25.316 28 22.0053 28H9.99467C6.684 28 4 25.316 4 22.0053V10C4 6.68667 6.68667 4 10 4V4Z"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10.8267 14.8V22"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15.6254 21.9999V17.7999C15.6254 16.1426 16.968 14.7999 18.6254 14.7999V14.7999C20.2827 14.7999 21.6254 16.1426 21.6254 17.7999V21.9999"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10.824 10.4507C10.6587 10.4507 10.524 10.5853 10.5254 10.7507C10.5254 10.916 10.66 11.0507 10.8254 11.0507C10.9907 11.0507 11.1254 10.916 11.1254 10.7507C11.1254 10.584 10.9907 10.4507 10.824 10.4507"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.tiktok.com/@verdecampo_"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                    >
                      <rect
                        x="4"
                        y="4"
                        width="24"
                        height="24"
                        rx="5"
                        stroke="#C2D7D5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.0001 15.3333H13.6733C12.0152 15.3328 10.6699 16.6752 10.6667 18.3333H10.6667C10.6667 20.3584 12.3084 22 14.3334 22V22C16.3585 22 18.0001 20.3584 18.0001 18.3333V10"
                        stroke="#CEDAD7"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M18 10C18 11.8409 19.4924 13.3333 21.3333 13.3333"
                        stroke="#CEDAD7"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="contact--info d-flex justify-content-center align-items-center py-4 text-light">
            <span className="me-1">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.6667 11.3333H12C11.632 11.3333 11.3334 11.0346 11.3334 10.6666V7.33329C11.3334 6.96529 11.632 6.66663 12 6.66663H12.6667C13.4034 6.66663 14 7.26329 14 7.99996V9.99996C14 10.7366 13.4034 11.3333 12.6667 11.3333Z"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4 11.3333H3.33333C2.59667 11.3333 2 10.7366 2 9.99996V7.99996C2 7.26329 2.59667 6.66663 3.33333 6.66663H4C4.368 6.66663 4.66667 6.96529 4.66667 7.33329V10.6666C4.66667 11.0346 4.368 11.3333 4 11.3333Z"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.3333 6.66667V6.33333C12.3333 3.94 10.3933 2 7.99996 2V2C5.60663 2 3.66663 3.94 3.66663 6.33333V6.66667"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.41667 14.1667H7.58333C7.12333 14.1667 6.75 13.7933 6.75 13.3333V13.3333C6.75 12.8733 7.12333 12.5 7.58333 12.5H8.41667C8.87667 12.5 9.25 12.8733 9.25 13.3333V13.3333C9.25 13.7933 8.87667 14.1667 8.41667 14.1667Z"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.25 13.3334H10.6667C11.4033 13.3334 12 12.7367 12 12V11.3334"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>

            <span className="text--info">Serviço de atendimento:</span>
            <a href="tel:08000310426">
              <strong className="text--info ms-2">0800 031 0426</strong>
            </a>
          </div>

          <div className="btn__wrapper">
            <a href="/onde-comprar" className="btn--orange">
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.5 13V13C10.843 13 9.5 11.657 9.5 10V10C9.5 8.343 10.843 7 12.5 7V7C14.157 7 15.5 8.343 15.5 10V10C15.5 11.657 14.157 13 12.5 13Z"
                  stroke="#F1F3F5"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.5 21C12.5 21 5.5 15.25 5.5 10C5.5 6.134 8.634 3 12.5 3C16.366 3 19.5 6.134 19.5 10C19.5 15.25 12.5 21 12.5 21Z"
                  stroke="#F1F3F5"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span className="h5 mb-0">Onde comprar</span>
            </a>
            <div className="mb-3"></div>
            <a
              href="https://loja.verdecampo.com.br/"
              className="btn--orange"
              target="_blank"
            >
              <svg
                className="me-1"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.79102 9.16602C7.79102 10.9387 9.22803 12.3757 11.0007 12.3757V12.3757C12.7733 12.3757 14.2104 10.9387 14.2104 9.16602"
                  stroke="white"
                  stroke-width="1.375"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.79102 6.41478V5.95625C7.79102 4.1836 9.22803 2.74658 11.0007 2.74658V2.74658C12.7733 2.74658 14.2104 4.1836 14.2104 5.95625V6.41478"
                  stroke="white"
                  stroke-width="1.375"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.92448 6.41479C4.95599 6.41479 4.15442 7.16787 4.09401 8.13448L3.67308 14.8693C3.60203 16.0063 4.00411 17.122 4.78408 17.9523C5.56406 18.7826 6.65255 19.2535 7.79171 19.2535H14.2107C15.3499 19.2535 16.4384 18.7826 17.2184 17.9523C17.9984 17.1221 18.4005 16.0063 18.3294 14.8693L17.9085 8.13448C17.8481 7.16787 17.0465 6.41479 16.078 6.41479H5.92448Z"
                  stroke="white"
                  stroke-width="1.375"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span className="h5 mb-0">Comprar online</span>
            </a>
            <a href="/quero-revender" className="btn--orange mt-3">
              <span className="h5 mb-0">Quero revender</span>
            </a>

          </div>
        </div>
      </div>

      <div style={{ position: scrolled ? "fixed" : "relative", width: "100%", zIndex: "1000" }}>
        <div id="topbar__wrapper" className="d-none d-lg-flex">
          <div className="container py-3">
            <div className="d-flex flex-row justify-content-between align-items-center">
              <span className="text--info">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.1666 11.3334H12.5C12.132 11.3334 11.8333 11.0347 11.8333 10.6667V7.33335C11.8333 6.96535 12.132 6.66669 12.5 6.66669H13.1666C13.9033 6.66669 14.5 7.26335 14.5 8.00002V10C14.5 10.7367 13.9033 11.3334 13.1666 11.3334Z"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.5 11.3334H3.83333C3.09667 11.3334 2.5 10.7367 2.5 10V8.00002C2.5 7.26335 3.09667 6.66669 3.83333 6.66669H4.5C4.868 6.66669 5.16667 6.96535 5.16667 7.33335V10.6667C5.16667 11.0347 4.868 11.3334 4.5 11.3334Z"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.8334 6.66667V6.33333C12.8334 3.94 10.8934 2 8.50002 2V2C6.10669 2 4.16669 3.94 4.16669 6.33333V6.66667"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.91667 14.1667H8.08333C7.62333 14.1667 7.25 13.7933 7.25 13.3333V13.3333C7.25 12.8733 7.62333 12.5 8.08333 12.5H8.91667C9.37667 12.5 9.75 12.8733 9.75 13.3333V13.3333C9.75 13.7933 9.37667 14.1667 8.91667 14.1667Z"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.75 13.3333H11.1667C11.9033 13.3333 12.5 12.7366 12.5 12V11.3333"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>
                  Serviço de atendimento:{" "}
                  <a href="tel:08000310426">
                    <strong>0800 031 0426</strong>
                  </a>{" "}
                </span>
              </span>
              <div className="flex-row justify-content-center align-items-center d-none">
                <div className="mx-2 d-flex flex-row justify-content-center align-items-center">
                  <svg
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.8348 2.9975V3.34955C11.8348 3.55663 11.883 3.76087 11.9756 3.94609L12.8886 5.77187C13.0728 6.13907 13.1687 6.5442 13.1687 6.95501C13.1687 8.43987 13.1687 11.8671 13.1687 12.806C13.1687 12.937 13.1473 13.0672 13.1055 13.1914L12.8291 14.0204C12.6627 14.5959 12.1393 14.9947 11.5403 15.0025H5.4598C4.88566 15.0025 4.37592 14.6351 4.19436 14.0904L3.96837 13.4125C3.87769 13.1409 3.83146 12.8563 3.83146 12.57C3.83146 11.3902 3.83146 8.33445 3.83146 6.95501C3.83146 6.54421 3.92738 6.13908 4.11158 5.77189L5.02467 3.94579C5.11723 3.76067 5.1654 3.55653 5.16535 3.34956V2.9975"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.25215 7.49945L7.49959 9.00008H9.50042L8.74785 10.5007"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.158 12.9577H3.86076"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.5632 5.12119H4.43693"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.1682 2.99747H4.83179"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span className="text--info px-1">
                    Alimentação prazerosa, empolgante e funcional
                  </span>
                </div>
              </div>
              <div className="group-ctas">
                <div>
                  <a
                    href="/comprar-online"
                    className="btn--orange"
                  >
                    <svg
                      className="me-1"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.79102 9.16602C7.79102 10.9387 9.22803 12.3757 11.0007 12.3757V12.3757C12.7733 12.3757 14.2104 10.9387 14.2104 9.16602"
                        stroke="white"
                        stroke-width="1.375"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.79102 6.41478V5.95625C7.79102 4.1836 9.22803 2.74658 11.0007 2.74658V2.74658C12.7733 2.74658 14.2104 4.1836 14.2104 5.95625V6.41478"
                        stroke="white"
                        stroke-width="1.375"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5.92448 6.41479C4.95599 6.41479 4.15442 7.16787 4.09401 8.13448L3.67308 14.8693C3.60203 16.0063 4.00411 17.122 4.78408 17.9523C5.56406 18.7826 6.65255 19.2535 7.79171 19.2535H14.2107C15.3499 19.2535 16.4384 18.7826 17.2184 17.9523C17.9984 17.1221 18.4005 16.0063 18.3294 14.8693L17.9085 8.13448C17.8481 7.16787 17.0465 6.41479 16.078 6.41479H5.92448Z"
                        stroke="white"
                        stroke-width="1.375"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <span>Comprar online</span>
                  </a>
                </div>
                <div>
                  <a href="/onde-comprar" className="btn--orange">
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.5 13V13C10.843 13 9.5 11.657 9.5 10V10C9.5 8.343 10.843 7 12.5 7V7C14.157 7 15.5 8.343 15.5 10V10C15.5 11.657 14.157 13 12.5 13Z"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.5 21C12.5 21 5.5 15.25 5.5 10C5.5 6.134 8.634 3 12.5 3C16.366 3 19.5 6.134 19.5 10C19.5 15.25 12.5 21 12.5 21Z"
                        stroke="#F1F3F5"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span>Onde comprar</span>
                  </a>
                </div>
                <div>
                  <a href="/quero-revender" className="btn--orange gap-1">

                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 4V6H20V4M4 7L3 12V14H4V20H13C12.95 19.66 12.92 19.31 12.92 18.95C12.92 17.73 13.3 16.53 14 15.53V14H15.54C16.54 13.33 17.71 12.96 18.91 12.96C19.62 12.96 20.33 13.09 21 13.34V12L20 7M6 14H12V18H6M18 15V18H15V20H18V23H20V20H23V18H20V15" fill="white" />
                    </svg>


                    <span>Quero revender</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="navbar__wrapper header bg-white"
          style={{ position: showMenu ? "fixed" : "relative" }}
        >
          <div className="w-100 py-3">
            <div className="navbar__items ">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Text
                    as="a"
                    cursor="pointer"
                    onClick={() => handleNavigate("/nossa-historia/")}
                    className={classActive("/nossa-historia/")}
                  >
                    <a href="/nossa-historia/">
                      Nossa História
                    </a>
                  </Text>
                </li>

                <div
                  className="menu-linhas-desktop nav-item dropdown position-relative"
                  onMouseEnter={() => setIsOpen(true)}
                  onMouseLeave={() => setIsOpen(false)}
                >
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="nossasLinhasDropdown"
                    role="button"
                    aria-expanded={isOpen}
                  >
                    Nossas Linhas
                  </a>
                  <ul className={`dropdown-menu position-absolute${isOpen ? " show" : ""}`} aria-labelledby="nossasLinhasDropdown">
                    {OursLines.map((line) => (
                      <li key={`linha-drop-${line.id}`}>
                        <a
                          className="dropdown-item"
                          href={`/nossas-linhas/${line.path}/`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigate(`/nossas-linhas/${line.path}/`);
                          }}
                        >
                          {line.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                <li className="nav-item">
                  <Text
                    as="a"
                    cursor="pointer"
                    onClick={() => handleNavigate("/receitas/")}
                    className={classActive("/receitas/")}
                  >
                    <a href="/receitas/">
                      Receitas
                    </a>
                  </Text>
                </li>
              </ul>

              <a className="navbar__logo navbar-brand" href="#">
                <Text
                  as="a"
                  cursor="pointer"
                  onClick={() => handleNavigate("/")}
                  className="nav-link"
                >
                  <a href="/">
                    <Logo />
                  </a>
                </Text>
              </a>

              <ul className="navbar-nav">
                <li className="nav-item">
                  <Text
                    as="a"
                    cursor="pointer"
                    onClick={() => handleNavigate("/blog/")}
                    className={classActive("/blog/")}
                  >
                    <a href="/blog/">
                      Blog
                    </a>
                  </Text>
                </li>
                <li className="nav-item">
                  <a
                    href="https://espacodanutri.com.br/"
                    className="nav-link"
                    target="_blank"
                  >
                    Espaço da Nutri
                  </a>
                </li>
                <li className="nav-item">
                  <Text
                    as="a"
                    cursor="pointer"
                    onClick={() => handleNavigate("/faq/")}
                    className={classActive("/faq/")}
                  >
                    <a href="/faq/">
                      Dúvidas
                    </a>
                  </Text>
                </li>
              </ul>

              <div
                id="burguer__button"
                className="d-flex d-md-none justify-content-center align-items-center"
                style={{ width: "50px", height: "50px" }}
                onClick={toggleMenu}
              >
                <svg
                  className="open"
                  width="41"
                  height="40"
                  viewBox="0 0 41 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.8">
                    <path
                      d="M11.33 13.9975H29.3375"
                      stroke="#212529"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M25.3358 20H11.33"
                      stroke="#212529"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.33 26.0025H21.3341"
                      stroke="#212529"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </svg>

                <svg
                  className="close"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.33374 8L16.3337 16"
                    stroke="#212529"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.3337 8L8.33374 16"
                    stroke="#212529"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}